var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tt-gift"},[_c('GiftInfo'),_c('GiftFAQ')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }